// extracted by mini-css-extract-plugin
module.exports = {"container":"payments_container__2Bw3U","title":"payments_title__2HFgo","content":"payments_content__2sAm0"};